import type { ProcessingJob } from "features/dt-plus-setup/model/types";

import { parseNumericId } from "./parseApiId";

export const findLatestJobConfigId = (jobs: ProcessingJob[]): number | undefined => {
  const ranked = jobs
    .map((job) => ({
      at: Date.parse(job.executed_at),
      id: parseNumericId(job, ["config_id", "configId"]),
    }))
    .filter((item): item is { at: number; id: number } => item.id != null)
    .sort((a, b) => (Number.isFinite(b.at) ? b.at : 0) - (Number.isFinite(a.at) ? a.at : 0));
  return ranked[0]?.id;
};
